import styled, { css } from "styled-components";

import { ReactComponent as IconCheck } from "assets/icons/checkmark.svg";
import { colors } from "../../styles";
import WhiteBox from "../WhiteBox";

const Root = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 170px;
  font-size: 13px;
  border: 0;
  background-color: transparent;
  padding: 10px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.lighterGray};
  }
`;

const CheckIcon = styled.div`
  position: absolute;
  top: 10px;
  background-color: ${colors.blue};
  padding: 5px;
  border-radius: 10px;

  img {
    display: block;
    fill: white;
  }
`;

const AccentBar = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 8px;
  background-color: ${colors.blue};
`;

const Label = styled.div`
  padding-top: 10px;
  ${(props) =>
    props.$selected &&
    css`
      font-weight: bold;
    `}
`;

const SquareBoxOption = ({ Icon, children, $selected, ...props }) => {
  return (
    <WhiteBox>
      <Root {...props}>
        {$selected && (
          <CheckIcon>
            <IconCheck
              width="10"
              style={{
                display: "block",
              }}
            />
          </CheckIcon>
        )}
        <div>
          <Icon width="50" />
          <Label $selected={$selected}>{children}</Label>
        </div>
        {$selected && <AccentBar />}
      </Root>
    </WhiteBox>
  );
};

export default SquareBoxOption;
